import type ContactVM from 'ab-viewModels/contact/contact';

import type ContactRM from 'ab-requestModels/contact/upsert';

import { formatPhoneNumberOld } from '@acceligentllc/shared/utils/phone';

import type { EmailTypes, PhoneTypes } from '@acceligentllc/shared/enums/contactMethodType';
import { CountryCode } from '@acceligentllc/shared/enums/countryCode';
import { UpsertContactStatus } from '@acceligentllc/shared/enums/upsertContactStatus';

export const fromVMtoRM = (contact: ContactVM): ContactRM => {
	return {
		id: contact.id,
		fullName: contact.fullName,
		companyName: contact.companyName,
		title: contact.title,
		phones: bulkToPhoneRequestModel(contact.phones),
		emails: bulkToEmailRequestModel(contact.emails),
		addresses: bulkToRequestModel(contact.addresses),
	};
};

const bulkToPhoneRequestModel = (contactMethods: ContactVM['phones']): ContactRM['phones'] => {
	return contactMethods.map(toPhoneRequestModel);
};

const toPhoneRequestModel = (method: ContactVM['phones'][number]): ContactRM['phones'][0] => {
	return {
		id: method.id,
		value: formatPhoneNumberOld(method.value)!,
		type: method.type as PhoneTypes,
		countryCode: method.countryCode ?? CountryCode.US,
		extension: method.extension,
		status: UpsertContactStatus.OLD,
	};
};

const bulkToEmailRequestModel = (contactMethods: ContactVM['emails']): ContactRM['emails'] => {
	return contactMethods.map(toEmailRequestModel);
};

const toEmailRequestModel = (method: ContactVM['emails'][number]): ContactRM['emails'][0] => {
	return {
		id: method.id,
		value: method.value,
		type: method.type as EmailTypes,
		status: UpsertContactStatus.OLD,
	};
};

const bulkToRequestModel = (contactAddresses: ContactVM['addresses']): ContactRM['addresses'] => {
	return contactAddresses.map(toRequestModel);
};

const toRequestModel = (contactAddress: ContactVM['addresses'][number]): ContactRM['addresses'][0] => {
	return {
		id: contactAddress.id,
		address: addressToRequestModel(contactAddress.address),
		status: UpsertContactStatus.OLD,
	};
};

const addressToRequestModel = (address: ContactVM['addresses'][number]['address']): ContactRM['addresses'][0]['address'] => {
	return {
		id: address.id,
		aa1: address.state,
		aa2: address.aa2,
		aa3: address.aa3,
		country: address.country,
		latitude: address.latitude,
		longitude: address.longitude,
		locality: address.city,
		postalCode: address.zip,
		route: address.route,
		street: address.street,
		streetNumber: address.streetNumber,
		suite: address.suite,
		postalOfficeBoxCode: address.postalOfficeBoxCode,
	};
};
